// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33IaT","col":"styles_col__2RclV"};